import { AlphaUCircleOutlineIcon } from './AlphaUCircleOutlineIcon';

/**
 * author: Contributors
 * id 12B388EE-036B-45AF-8390-122E6BA125CF
 * name alpha-u-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterUCircleOutlineIcon = AlphaUCircleOutlineIcon;
export default LetterUCircleOutlineIcon